var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0875C4",
    fillRule: "evenodd",
    d: "m7.84 14.3 8.902-8.901a.823.823 0 0 0-1.163-1.164l-8.496 8.496h.001l-.405.405-.34.339-.54.537-.16 1.32 1.321-.154zm1.582.776 8.499-8.499a2.49 2.49 0 0 0-3.52-3.52l-8.9 8.899-1.288 1.284-.482 3.995 3.997-.47.952-.949.339-.337z",
    clipRule: "evenodd"
  })));
};
export { SvgEdit as Icon };
export default __webpack_public_path__ + "static/media/7492f3fde07fbf76bf33570511f958b4.svg";